import { DateRange, DateRangePicker, DateRangePickerProps } from 'bold-ui'

import { UseFieldProps, usePecField } from '../../core/hooks/useField'
import { getFieldError } from '../../core/util'
import { DateRangeFieldType } from './model-dateRange'
import { isDateRangeFieldEqual } from './utils-dateRange'

type DateRangeFieldProps = UseFieldProps<DateRangeFieldType> & Omit<DateRangePickerProps, 'name'>

export function DateRangeField(props: DateRangeFieldProps) {
  // TODO (@RNG): Ajustar tipagem para não precisar de cast #29612
  const castOptions = {
    ...props,
    isEqual: isDateRangeFieldEqual,
  } as UseFieldProps<DateRange>

  const { input, meta, ...rest } = usePecField(castOptions)

  return <DateRangePicker error={getFieldError(meta)} {...input} {...rest} />
}
